import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import { API_STATUS } from "../../constants/apiStatus";

// Unified protected route using Redux auth state (with sessionStorage fallback for legacy code)
const ProtectedAdminRoute = ({ children }) => {
  const { isAuthenticated, apiStatus: authApiStatus } = useAppSelector(
    (state) => state.auth
  );
  const legacySession = (() => {
    try {
      return sessionStorage.getItem("adminAuthenticated") === "true";
    } catch (_) {
      return false;
    }
  })();

  // Check if we have a stored token
  const storedToken = localStorage.getItem("authToken");
  const isVerifying = authApiStatus.verify === API_STATUS.STARTED;

  // If we have a token and are currently verifying, allow access (loading state will show)
  if (storedToken && isVerifying) {
    return children;
  }

  if (isAuthenticated || legacySession) {
    return children;
  }

  return <Navigate to="/admin" replace />;
};

export default ProtectedAdminRoute;
